import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import Form from './Form'

@inject('centerStore', 'stepOneStore')
@observer
export default class extends Component {
  componentDidMount = () => {
    const { centerStore, stepOneStore } = this.props
    const {
      getOrderAndPayAllGiftHistory,
      getSeriesList,
      getVipTagList,
      getSecondCategoryList
    } = stepOneStore

    getOrderAndPayAllGiftHistory()
    const property_id = centerStore.property_id

    if (property_id == 14) {
      // 获取系列列表
      getSeriesList()
    }
    if (property_id == 6) {
      // 婚纱摄影获取专享服务
      getVipTagList()
    }

    if (property_id == 6 || property_id == 12 || property_id == 14) {
      // 婚纱摄影、婚纱礼服、婚戒首饰 获取二级类目列表
      getSecondCategoryList()
    }
  }

  render() {
    return (
      <div>
        <Form routeId={this.props.params.id} store={this.props.stepOneStore} />
      </div>
    )
  }
}
